import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
`;

const StyledControlsContainer = styled.div`
	position: absolute;
	left: 0;
	bottom: 80px;
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 0 80px;
	transition: opacity 0.3s ease;
`;

const StyledRightContainer = styled.div`
	position: absolute;
	top: 80px;
	right: 80px;
	display: flex;
	gap: 40px;
	transition: opacity 0.3s ease;
`;

const StyledCloseButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 10px;
	background-color: #111314;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	img {
		transition: filter 0.3s ease;
		pointer-events: none;
		user-select: none;
	}
`;

export {
	StyledCloseButtonContainer,
	StyledContainer,
	StyledControlsContainer,
	StyledRightContainer,
};
